import { ValidateFileInput } from "@src/config/helper";
import { VehiclePhotosProps } from "./interface";
import { useLanguage } from "@src/context/LanguageContext";

const VehiclePhotos = (props: VehiclePhotosProps) => {
  const {
    index,
    item,
    documentList,
    setDocumentList,
    addComment,
    setDeleteDocs,
  } = props;

  const handleFileChange = async (
    e: any,
    child: any,
    uploadIndex: any = null,
  ) => {


    let selectedFile = e.target.files;
    let validateFile = await ValidateFileInput(selectedFile);
    if(validateFile) return;
    const updatedChild = item.child.map((el: any, index: number) => {
      if (el.value === child.value) {
        const updatedSrc = [...(el.src || [])];
        updatedSrc[uploadIndex] = selectedFile?.[0];
        return {
          ...el,
          src: updatedSrc,
          is_file_resubmit:false
        };
      }

      return el;
    });

    const updatedDocumentList = documentList?.map((e: any) => {
      let updatedItem = { ...e };
      if (e.value === item.value) {
        updatedItem = { ...updatedItem, child: updatedChild };
      }
      return updatedItem;
    });

    setDocumentList(updatedDocumentList);
  };
  const removeVehiclePhotos = (child: any, uploadIndex: number) => {
    const updatedChild = item.child.map((el: any, index: number) => {
      if (el.value === child.value) {
        const updatedSrc = [...(el.src || [])];
        delete updatedSrc[uploadIndex];
        return {
          ...el,
          src: updatedSrc,
        };
      }
      if (child.src[uploadIndex]?.id) {
        setDeleteDocs((pre: any) => {
          const newArr = [...pre];
          if (!newArr.includes(child.src[uploadIndex]?.id)) {
            newArr.push(child.src[uploadIndex]?.id);
          }
          return newArr;
        });
      }

      return el;
    });

    const updatedDocumentList = documentList?.map((e: any) => {
      let updatedItem = { ...e };
      if (e.value === item.value) {
        updatedItem = { ...updatedItem, child: updatedChild };
      }
      return updatedItem;
    });
    setDocumentList(updatedDocumentList);
  };

  const {translations} = useLanguage();

  return (
    
    <div className="col-md-12">
      {item.child?.map((subChild: any, subIndex: number) => (

        <>
         
        <div key={`${item.label}-${subIndex}`} className="row">
          <span className="col-md-12 upload-images-title">
            {subChild.label}

            {subChild.is_resubmit && subChild?.comment && (
                  <div className="resub-note m-lg-t">
                    <b>{translations?.CREATE_APP?.RESUBMIT_NOTE} :</b> {subChild.comment}
                  </div>
                )}
          </span>
          

          {Array.from(
            { length: subChild.max_upload || 1 },
            (_, uploadIndex) => {
               
              const imgObj = subChild?.src?.[uploadIndex];
             
              let file = imgObj?.src;
              if (!imgObj?.src) file = imgObj;
              let isFileString = typeof file === "string" ? true : false; 
               

              let ext = file?.name?.split(".").pop()?.toLowerCase();
              if (["csv", "xls", "xlsx"].includes(ext)) ext = "excel";
              if (["doc", "docx"].includes(ext)) ext = "word";
              

              return (
                <div
                  key={`${subIndex}-${uploadIndex}`}
                  className="col-md-2 col-xs-6 p-lg-t"
                >
                  {!file && (
                    <div className="add-document-proof mt-2 m-lg-b" role="presentation">
                      <input
                        type="file"
                        name="documents[]"
                        disabled={!subChild?.is_resubmit}
                        onChange={(e: any) =>
                          handleFileChange(e, subChild, uploadIndex)
                        }
                      />

                      <i className="ic-add"></i>
                      <span>{translations?.COMMON_MSG?.UPLOAD}</span>
                    </div>
                  )}

                  {/* 🔥 Preview INSIDE upload box */}
                  {file && (
                    <div
                      className={subChild?.is_file_resubmit ? "upload-image-proof-ra mt-2" : "upload-image-proof-r mt-2"}
                      id={`upload-image-input-${subChild.value}`}
                    >

                        {
                            
                            subChild?.is_resubmit && (
                                <span
                                    className="close-icn"
                                    onClick={() =>
                                    isFileString
                                        ? removeVehiclePhotos(subChild, uploadIndex)
                                        : removeVehiclePhotos(subChild, uploadIndex)
                                    }
                                >
                                    <i className="ic-clearclose"></i>
                                </span>
                            )
                        }

                      {["jpg", "jpeg", "png"].includes(ext) ||
                       file ? (
                        <img
                          src={isFileString ? file : URL.createObjectURL(file)}
                          alt=""
                        />
                      ) : (
                        <a
                          href={isFileString ? file : URL.createObjectURL(file)}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <i className={`ic-${ext}-file f-50`} />
                        </a>
                      )}
                    </div>
                  )}
                </div>
                
              );
            },
          )}


            {subChild.is_resubmit && (
              <div className="col-md-12">
                <div className="row">
                  <div className="row document-remarks textarea-field col-md-4">
                    <fieldset className="form-filed w-100">
                      <div className="material">
                        <textarea
                          className="form-input"
                          placeholder=" "
                          onChange={(e: any) => {
                            addComment(index, e.target.value, subIndex);
                          }}
                        ></textarea>
                        <label data-label={translations?.COMMON_MSG?.COMMENT} className="form-label"></label>
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>
                  )}
          
        </div>
        </>
        
      ))}
    </div>
  );
};
export default VehiclePhotos;
